export const commandTypeFusion = 'fusionCob';
export const commandTypeNChannel = 'nChannel';

export const commandType = [commandTypeFusion, commandTypeNChannel] as const;
export type CommandType = typeof commandType[number];
